import SectionGraphQLManager from './SectionGraphQLManager'

export default SectionGraphQLManager
// eslint-disable-next-line import/export
export * from './SectionGraphQLManager'
